import styled from 'styled-components';

export const Container = styled.div``;

export const Title = styled.span`
  font-family: 'Mangueira';
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  color: #3d3d3d;
`;

export const SubTitle = styled.span`
  display: inline-block;
  margin-top: 12px;
  font-family: 'Mangueira';
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  color: #3d3d3d;
  margin-bottom: 12px;
`;

export const Text = styled.span`
  display: inline-block;
  margin-top: 12px;
  font-family: 'Mangueira';
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  color: #3d3d3d;
  padding-left: 12px;
`;

export const ButtonOK = styled.button`
  margin-top: 24px;
  width: 100%;
  height: 40px;
  border-radius: 6px;
  border: 1px solid #0b29fb;
  background: transparent;

  font-family: 'Mangueira';
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  color: #0b29fb;

  &:hover {
    filter: brightness(0.9);
  }
`;

export const TitleWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const TextsWrapper = styled.div``;
